import React from 'react';
import { CwLog, AsyncComponent } from 'cw-ui-core';

const getScreen = (screenId, props = null) => {
  switch (screenId) {
    case 'shoppingcart':
    return (
      <AsyncComponent
        key={screenId}
        {...props}
        loader={(cb) => {
          System.import('./components/ShoppingCart/ShoppingCartContainer')
            .then((component) => {
              cb(component);
            });
        }}
      />);
    case 'university':
    return (
      <AsyncComponent
        key={screenId}
        {...props}
        loader={(cb) => {
          System.import('./components/University/University')
            .then((component) => {
              cb(component);
            });
        }}
      />);
    default:
      CwLog.error(`No screen found for ${screenId}`);
  }
};

export default getScreen;


// WEBPACK FOOTER //
// ./src/ScreenFactory.js